import { createFileRoute } from "@tanstack/react-router";

import { RetrievalEvaluationPage } from "@/features/retrieval-evaluation/RetrievalEvaluationPage";

export const Route = createFileRoute("/_authenticated/evaluation/retrieval")({
  component: RetrievalEvaluationPage,
});
